import React from 'react';

import FormElementWrapper from './FormElementWrapper';

interface InputProps {
    inputValidationState?: string,
    inputId: string,
    inputLabel?: string,
    notRequired?: boolean,
    prefixIcon?: string,
    suffixIcon?: string,
    inputValidationMessage?: string,
    elementCustomClass?: string,
    isDisabled?: boolean,
    inputSize?: string,
    inputType?: string,
    inputPlaceholder?: string,
    inputValue?: string,
    inputCustomClass?: string,
    // eslint-disable-next-line no-unused-vars
    inputOnChange?: (event: InputEvent) => void
}

const Input = (props: InputProps) => {
    const {
        inputValidationState,
        inputId,
        inputLabel,
        notRequired,
        prefixIcon,
        suffixIcon,
        inputValidationMessage,
        elementCustomClass,
        isDisabled,
        inputSize,
        inputType,
        inputPlaceholder,
        inputValue,
        inputCustomClass,
        inputOnChange
    } = props;

    return (
        <FormElementWrapper
            elementValidationState={inputValidationState}
            elementId={inputId}
            elementLabel={inputLabel}
            notRequired={notRequired}
            prefixIcon={prefixIcon}
            suffixIcon={suffixIcon}
            elementValidationMessage={inputValidationMessage}
            elementCustomClass={elementCustomClass}
            isDisabled={isDisabled}
            elementSize={inputSize}
        >
            <input
                type={inputType}
                id={inputId}
                placeholder={inputPlaceholder}
                required={!notRequired}
                value={inputValue}
                className={inputCustomClass}
                onChange={inputOnChange}
            />
        </FormElementWrapper>
    );
};

export default Input;
